export var HtmlTypeAttribute;
(function (HtmlTypeAttribute) {
    HtmlTypeAttribute["BUTTON"] = "button";
    HtmlTypeAttribute["SUBMIT"] = "submit";
    HtmlTypeAttribute["RESET"] = "reset";
})(HtmlTypeAttribute || (HtmlTypeAttribute = {}));
//# sourceMappingURL=HtmlTypeAttribute.js.map